// Process links like https://example.org/
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
export default function linkify(state, silent) {
  if (!state.md.options.linkify) return false;
  if (state.linkLevel > 0) return false;
  var pos = state.pos;
  var max = state.posMax;
  if (pos + 3 > max) return false;
  if (state.src.charCodeAt(pos) !== 0x3A
  /* : */
  ) return false;
  if (state.src.charCodeAt(pos + 1) !== 0x2F
  /* / */
  ) return false;
  if (state.src.charCodeAt(pos + 2) !== 0x2F
  /* / */
  ) return false;
  var match = state.pending.match(SCHEME_RE);
  if (!match) return false;
  var proto = match[1];
  var link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
  if (!link) return false;
  var url = link.url; // invalid link, but still detected by linkify somehow;
  // need to check to prevent infinite loop below

  if (url.length <= proto.length) return false; // disallow '*' at the end of the link (conflicts with emphasis)

  url = url.replace(/\*+$/, '');
  var fullUrl = state.md.normalizeLink(url);
  if (!state.md.validateLink(fullUrl)) return false;

  if (!silent) {
    state.pending = state.pending.slice(0, -proto.length);
    var token_o = state.push('link_open', 'a', 1);
    token_o.attrs = [['href', fullUrl]];
    token_o.markup = 'linkify';
    token_o.info = 'auto';
    var token_t = state.push('text', '', 0);
    token_t.content = state.md.normalizeLinkText(url);
    var token_c = state.push('link_close', 'a', -1);
    token_c.markup = 'linkify';
    token_c.info = 'auto';
  }

  state.pos += url.length - proto.length;
  return true;
}